import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const paymentBaseEndpoint = ENDPOINTS.PAYMENT;

// Payment Options API
export const paymentsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["payment-options"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPaymentOptions: builder.query({
        query: (payload) => `${paymentBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "payment-options" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      
      addPaymentOption: builder.mutation({
        query: (requestData) => ({
          url: `${paymentBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "payment-options" }],
      }),
      updatePaymentOption: builder.mutation({
        query: ({id,requestData}) => ({
          url: `${paymentBaseEndpoint}${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "payment-options" }],
      }),
      togglePaymentOptionStatus: builder.mutation({
        query: ({id,requestData}) => ({
          url: `${paymentBaseEndpoint}toggle/${id}`,
            method: METHODS.PATCH,
            body: requestData,
        }),
        invalidatesTags: () => [{ type: "payment-options" }],
      }),
      deletePaymentOption: builder.mutation({
        query: (id) => ({
          url: `${paymentBaseEndpoint}${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "payment-options" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useAddPaymentOptionMutation, 
  useGetPaymentOptionsQuery, 
  useTogglePaymentOptionStatusMutation, 
  useUpdatePaymentOptionMutation,
  useDeletePaymentOptionMutation
} = paymentsApi;
